// Initialise the Raven Error reporting for Sentry
// This will only happen in prod

export default () => {
  if (window.Raven) {
    window.Raven.config('https://5d652e6e1b224e8bb717586635a1ae44@sentry.io/1243653').install()
  }
}



// WEBPACK FOOTER //
// ./src/app/init/initRaven.js